<template>
  <div
    class="relative rounded"
    :class="errors.length > 0 ? 'shadow-outline-error' : ''"
  >
    <mia-multi-select
      v-bind="attrs"
      :class="{ 'is-required': required }"
      v-on="listeners"
    />

    <mia-fade-transition>
      <small
        v-if="errors.length > 0"
        class="absolute bottom-0 block leading-3 text-red-600 pointer-events-none"
        style="transform: translateY(17px)"
      >
        {{ errors[0] }}
      </small>
    </mia-fade-transition>
  </div>
</template>

<script>
import { getSellers } from '@/api/dealer'
import { fullName } from '@/helpers/utils'

export default {
  name: 'MiaSellerSelect',

  props: {
    value: {
      required: true,
      validator: () => true
    },

    required: {
      type: Boolean,
      default: false
    },

    errors: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      sellers: []
    }
  },

  computed: {
    attrs() {
      return {
        ...this.$attrs,
        'custom-label': this.getCustomLabel,
        flatten: true,
        options: this.sellers,
        'track-by': 'id',
        value: this.value
      }
    },

    listeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          if (this.$listeners.input) {
            this.$listeners.input(event)
          }
        }
      }
    }
  },

  async created() {
    this.sellers = await getSellers()

    const authSeller = this.sellers.find(({ id }) => parseInt(id, 10) === parseInt(this.authUser.id, 10))

    if (authSeller) {
      this.$emit('input', authSeller.id)
    }
  },

  methods: {
    getCustomLabel(sellerId) {
      const seller = this.sellers.find(({ id }) => parseInt(id, 10) === parseInt(sellerId, 10))

      return fullName(seller.lastname, seller.firstname)
    }
  }
}
</script>

<style scoped>
.is-required ::v-deep .multiselect__tags {
  border-left-width: calc(theme('width.px') * 3);
  border-left-color: theme('borderColor.orange-mia');
}
</style>
